import { createContext, useContext } from 'react';

/** Identifiants fournis par `<Field>` à son contrôle (Input, Textarea, NativeSelect). */
export interface FieldControlContext {
  id: string;
  describedBy: string | undefined;
  invalid: boolean;
}

export const FieldContext = createContext<FieldControlContext | null>(null);

/**
 * Attributs d'accessibilité du contrôle placé dans un `<Field>` : `id` relié au
 * libellé, `aria-describedby` vers l'aide et l'erreur, `aria-invalid`. Les props
 * explicites du contrôle gardent la priorité. L'astérisque `required` du
 * `<Field>` reste visuel : la validation reste celle du formulaire (zod).
 */
export function useFieldControl(props: {
  id?: string | undefined;
  'aria-describedby'?: string | undefined;
  'aria-invalid'?: boolean | 'true' | 'false' | 'grammar' | 'spelling' | undefined;
}): {
  id: string | undefined;
  'aria-describedby': string | undefined;
  'aria-invalid': boolean | 'true' | 'false' | 'grammar' | 'spelling' | undefined;
} {
  const field = useContext(FieldContext);
  return {
    id: props.id ?? field?.id,
    'aria-describedby': props['aria-describedby'] ?? field?.describedBy,
    'aria-invalid': props['aria-invalid'] ?? (field?.invalid === true ? true : undefined),
  };
}
